<template>
  <div class="ies-app container">
    <!--  Loading gif    -->
    <div :class="{ 'is-loading': isLoading }">
      <span></span>
    </div>

    <dashboard v-if="page === 'dashboard'" />

    <exam v-if="page === 'exam'" />

    <result v-if="page === 'results'" />

    <review v-if="page === 'review'" />

    <surveyComponent v-if="page === 'survey'" />

    <InvigilateWarning v-if="page === 'invigilate_warning'" />

    <InvigilateSetup v-if="page === 'invigilate_setup'" />

    <PreStartVideo v-if="page === 'pre_start_video'" />

    <threshold-exceeded v-if="page === 'threshold_exceeded'" />
  </div>
</template>

<script>
import Dashboard from './components/Dashboard/Dashboard.vue'
import Exam from './components/Exam/Exam.vue'
import Result from './components/Result/Result.vue'
import Review from './components/Review/Review'
import InvigilateWarning from './components/Invigilate/InvigilateWarning'
import InvigilateSetup from './components/Invigilate/InvigilateSetup'
import PreStartVideo from './components/Invigilate/PreStartVideo'
import SurveyComponent from './components/Survey/SurveyComponent'
import ThresholdExceeded from './components/Alerts/ThresholdExceeded'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['isLoading', 'page'])
  },
  props: {
    user_id: {
      type: Number
    },
    user_email: {
      type: String
    },
    first_name: {
      type: String
    },
    last_name: {
      type: String
    },
    exam_id: {
      required: true,
      type: Number
    },
    go_to_user_dash_on_back_click: {
      type: Boolean,
      default: false
    },
    user_dashboard_url: {
      type: String
    },
    is_demo: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Dashboard,
    Exam,
    Result,
    Review,
    SurveyComponent,
    ThresholdExceeded,
    InvigilateSetup,
    InvigilateWarning,
    PreStartVideo
  },

  created() {
    this.$store.dispatch('initializeApp', {
      user_id: this.user_id,
      exam_id: this.exam_id,
      user_email: this.user_email,
      first_name: this.first_name,
      last_name: this.last_name,
      go_to_user_dash_on_back_click: this.go_to_user_dash_on_back_click,
      user_dashboard_url: this.user_dashboard_url,
      is_demo: this.is_demo
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto');
@import './assets/sass/ies';
</style>
